<template>
  <eg-form-group
    :label="noLabel ? '' : 'Assignment'"
    :description="description"
    class="position-relative"
    :info="info"
    :required="required"
  >
    <eg-b-overlay :show="loading" no-wrap>
      <template #overlay>
        <eg-b-spinner small variant="info" />
      </template>
    </eg-b-overlay>

    <template>
      <eg-search-select
        v-if="withSearch"
        :items="assignmentsData"
        :value="selectedAssignment"
        title-key="name"
        entity="assignment"
        :allow-deselect="allowDeselect"
        :required="required"
        :submitted="submitted"
        @input="selectAssignment"
        v-on="listeners"
      >
        <template #item="{ item }">
          <slot v-if="$scopedSlots.item" name="item" :assignment="item"></slot>
          <template v-else>
            <div class="text-truncate">
              {{ item.name }}
            </div>
          </template>
        </template>
      </eg-search-select>

      <eg-dropdown
        v-else
        size="sm"
        :text="
          selectedAssignment ? selectedAssignment.name : 'Select assignment'
        "
      >
        <eg-b-dropdown-item-button
          v-for="assignment in assignmentsData"
          :key="assignment.id"
          class="dropdown-item-wrapper"
          @click="() => selectAssignment(assignment)"
        >
          <slot
            v-if="$scopedSlots.item"
            name="item"
            :assignment="assignment"
          ></slot>
          <template v-else>
            {{ assignment.name }}
          </template>
        </eg-b-dropdown-item-button>
      </eg-dropdown>
    </template>
  </eg-form-group>
</template>

<script>
import EgFormGroup from "@/components/global/eg_form_group";
import EgDropdown from "@/components/global/eg_dropdown";
import EgSearchSelect from "@/components/global/eg_search_select.vue";

export default {
  components: {
    EgDropdown,
    EgSearchSelect,
    EgFormGroup,
  },
  inject: ["workspacesProvider"],
  props: {
    value: {
      type: Object,
      default: () => {},
    },

    withSearch: {
      type: Boolean,
      default: false,
    },

    noLabel: {
      type: Boolean,
      default: false,
    },

    info: {
      type: String,
      default: "",
    },

    description: {
      type: String,
      default: "",
    },

    showCreateEntity: {
      type: Boolean,
      default: true,
    },

    allowDeselect: {
      type: Boolean,
      default: false,
    },

    autoSelectFirst: {
      type: Boolean,
      default: false,
    },

    required: {
      type: Boolean,
      default: false,
    },

    submitted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      selectedAssignment: null,
      assignmentsData: [],
    };
  },

  computed: {
    listeners() {
      if (!this.showCreateEntity) {
        return {};
      }

      return {
        "click:create": this.onClickCreate,
      };
    },
  },

  created() {
    this.selectedAssignment = this.value;
    this.fetchAssignments();
  },

  methods: {
    onClickCreate() {
      this.$openForm("assignment", {
        props: { isRedirectAfterCreated: false },
        callback: async (value) => {
          await this.fetchAssignments();
          this.selectAssignment(value);
        },
      });
    },

    selectAssignment(assignmentData) {
      this.selectedAssignment = assignmentData;
      this.$emit("input", assignmentData);
    },

    async fetchAssignments() {
      const { assignments } =
        this.workspacesProvider.extractClassesAndAssignments(
          this.workspacesProvider.getAllFolders()
        );

      this.assignmentsData = assignments;
      this.$emit("input:assignments", this.assignmentsData);

      if (this.autoSelectFirst && this.assignmentsData.length > 0) {
        this.selectAssignment(this.assignmentsData[0]);
      }
    },
  },
};
</script>
